export enum ColumnId {
  Details = 'Details',
  Open = 'Open',
  Status = 'Status',
  Action = 'Action',
}

export type SearchableScopeChangeRequestSortField = 'create_time' | 'id'

export type ScopeChangeRequestColumnDetails = {
  id: ColumnId
  header: string
  align: 'left' | 'right' | 'center'
  select: boolean
  sortable: boolean
  field?: SearchableScopeChangeRequestSortField
}

export const ScopeChangeRequestTableColumns: ScopeChangeRequestColumnDetails[] =
  [
    {
      id: ColumnId.Details,
      header: 'Details',
      select: false,
      align: 'left',
      sortable: false,
    },
    {
      id: ColumnId.Open,
      header: 'Open',
      select: false,
      align: 'left',
      sortable: true,
      field: 'create_time',
    },
    {
      id: ColumnId.Status,
      header: 'Status',
      select: false,
      align: 'center',
      sortable: false,
    },
    {
      id: ColumnId.Action,
      header: '',
      select: false,
      align: 'left',
      sortable: false,
    },
  ]
